export class AlerteMessage {
  title: string;
  text: string;
  messages?: string[];
}
